module.exports = __webpack_public_path__ + "static/media/valikko-asuminen.d28f0f94.jpg";